













import Vue from 'vue';
import FormField from './FormField.vue';
import customerVuex from '../../../vuex/common';

const options = [
  {value: true, label: '关注中'},
  {value: false, label: '已取关'},
  {value: undefined, label: '全部'},
];

export default Vue.extend({
  mixins: [customerVuex],
  data() {
    return {
      options,
      idx: 0,
    };
  },
  components: {
    FormField,
  },
  computed: {
    status(): boolean | undefined {
      return this.customerFilter.subscribeStatus;
    },
    transformOf(): string {
      const offset = this.idx * 100 - 300;
      return `transform: translateX(${offset}%)`;
    },
  },
  methods: {
    changeStatus(idx: number, status?: boolean) {
      this.customerFilter.subscribeStatus = status;
      this.idx = idx;
    },
  },
});
